import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutBase extends Component {
  @service billingModals;
  @service paymentInstrumentModals;
  @service stripeExpressCheckoutElementService;

  get paymentModel() {
    return this.args.model;
  }

  get selectionGroupName() {
    return this.args.selectionGroupName ?? 'paymentInstrument';
  }

  get actionsDisabled() {
    return (
      this.billingModals.isPaymentInvalid ||
      this.paymentInstrumentModals.isPersisting ||
      this.stripeExpressCheckoutElementService.isOpen ||
      this.stripeExpressCheckoutElementService.isPersisting
    );
  }
}
